import './amplify';
import './i18n';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Authenticator } from '@aws-amplify/ui-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import '@aws-amplify/ui-react/styles.css';
import './styles.css';
import './tailwind.css';
import App from './App';
import ChatSimulator from './ChatSimulator';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
});

const components = {
  Header() {
    return (
      <div className="auth-logo">
        <img src="/SmartBot_Logo-Final.png" alt="SmartBot by Klaro360" />
      </div>
    );
  },
};

const formFields = {
  signIn: {
    username: { label: 'אימייל', placeholder: 'הזינו את האימייל שלכם' },
    password: { label: 'סיסמה', placeholder: 'הזינו את הסיסמה שלכם' },
  },
  forceNewPassword: {
    password: { label: 'סיסמה חדשה', placeholder: 'הזינו סיסמה חדשה' },
  },
  resetPassword: {
    username: { label: 'אימייל', placeholder: 'הזינו את האימייל שלכם' },
  },
  confirmResetPassword: {
    confirmation_code: { label: 'קוד אימות', placeholder: 'הזינו את הקוד ששלחנו' },
    password: { label: 'סיסמה חדשה', placeholder: 'הזינו סיסמה חדשה' },
    confirm_password: { label: 'אימות סיסמה', placeholder: 'הזינו שוב את הסיסמה' },
  },
};

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Authenticator hideSignUp variation="modal" formFields={formFields} components={components}>
      {({ signOut }) => (
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <Routes>
              {/* Hidden SystemAdmin-only chat simulator (no sidebar entry). */}
              <Route path="/chat" element={<ChatSimulator />} />
              <Route path="*" element={<App signOut={signOut} />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors dir="rtl" />
        </QueryClientProvider>
      )}
    </Authenticator>
  </React.StrictMode>,
);
